// Copyright 2026. WebPros International GmbH. All rights reserved.

import { NetworkType } from 'common/api/resources/ComputeResource';

export enum COMPUTE_RESOURCE_STATUS {
    CONFIGURE_NETWORK = 'configure_network',
    CONFIGURING_NETWORK = 'configuring network',
    COMMISSIONING = 'commissioning',
    ACTIVE = 'active',
    FAILED = 'failed',
    UNAVAILABLE = 'unavailable'
}

export enum COMPUTE_RESOURCE_STORAGE_STATUS {
    AVAILABLE = 'available',
    UNAVAILABLE = 'unavailable',
    UNKNOWN = 'unknown',
}

export enum COMPUTE_RESOURCE_HA_STATUS {
    PROTECTED = 'protected',
    NOT_ELIGIBLE = 'not_eligible',
    ELIGIBLE = 'eligible',
    PAUSED = 'paused',
    AT_RISK = 'at_risk',
    UNAVAILABLE = 'unavailable',
    NOT_PROTECTED = 'not_protected',
}

// String-valued on purpose: with auto-numbered members, inserting one silently shifts the
// ordinals of every member below it, which is how the CR page's edit dialog broke (SVM2-7365).
export enum COMPUTE_RESOURCE_DIALOG {
    NONE = 'none',
    COMPUTE_RESOURCE_CREATE = 'computeResourceCreate',
    COMPUTE_RESOURCE_VIEW = 'computeResourceView',
    STORAGE = 'storage',
    SETTINGS = 'settings',
    COMPUTE_RESOURCE_EDIT = 'computeResourceEdit',
    COMPUTE_RESOURCE_SETTINGS = 'computeResourceSettings',
}

export enum COMPUTE_RESOURCE_AUTH_TYPE {
    LKEY = 'lkey',
    LPASS = 'lpass',
}

const humanNetworkTypeMap = {
    [NetworkType.BRIDGED]: 'bridged',
    [NetworkType.ROUTED]: 'routed',
    [NetworkType.VZ_ROUTED]: 'vz routed',
};

export const humanizeNetworkType = (type: NetworkType): string => humanNetworkTypeMap[type];
